import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNpm: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="npm"><path d="M3 21H12V7.5H16.5V21H21V3H3V21Z" fill="currentColor"/></CentralIconBase>;
};

export default IconNpm;
